import React, { useState } from 'react';
import DsButton from '../../common/DsButton';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../../contexts/AuthContext';
import { resolveAdminPermission } from '../../../constants/adminPermissionCatalog';
import DetailActionMenu from '../../common/detail/DetailActionMenu';
import EventListAssignmentModal, { AssignmentsSaved } from './EventListAssignmentModal';
import { getAdminId } from '../../../utils/eventAssignments';
import '../../../css/admin/events/EventNavigationMenu.css';

export const eventNavigationItems = [
  { key: 'assignments', label: '担当者を追加・変更', permissions: ['EVENT_VIEW_CASTING_SETTINGS', 'EVENT_EDIT_INFO', 'EVENT_EDIT_CASTING_SETTINGS'] },
  { key: 'casting-workbench', label: 'キャスティング一覧', permissions: ['ARTIST_VIEW_LIST', 'ARTIST_VIEW_PROFILE_BASIC', 'EVENT_VIEW_CONTRACT_STATUS', 'EVENT_VIEW_PARTICIPANTS', 'NAV_CASTING_OFFER', 'NAV_CASTING_CONTRACT'] },
  { key: 'casting-progress', label: 'キャスティング配置', permissions: ['EVENT_VIEW_PARTICIPANTS'] },
  { key: 'stage-seating', label: 'ステージシーティング', permissions: ['EVENT_VIEW_PARTICIPANTS'] },
  { key: 'timetable', label: 'タイムテーブル', permissions: ['EVENT_VIEW_TIMETABLE'] },
  { key: 'participant-artists', label: '参加アーティスト', permissions: ['EVENT_VIEW_PARTICIPANTS'] },
  { key: 'ticket-sales', label: '券売状況', permissions: ['EVENT_VIEW_TICKET_SALES'] },
  { key: 'surveys', label: 'アンケート', permissions: ['NAV_SURVEYS'] },
];

export default function EventNavigationMenu({ event, placement = 'row', onlyCasting = false, onAssignmentsSaved }: {
  event: { event_uuid: string; name?: string }; placement?: 'row' | 'card' | 'detail'; onlyCasting?: boolean;
  onAssignmentsSaved?: AssignmentsSaved;
}) {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [assignmentOpen, setAssignmentOpen] = useState(false);
  if (!event?.event_uuid) return null;
  const actions = eventNavigationItems.filter(item => (!onlyCasting || item.key === 'casting-workbench') && item.permissions.every(permissionKey => resolveAdminPermission({
    role: user?.role || 'general', permissions: user?.permissions || [],
    isExternalAccount: user?.is_external_account === true, permissionKey,
  }))).map(item => ({ key: item.key, label: item.label,
    onClick: () => item.key === 'assignments'
      ? setAssignmentOpen(true)
      : navigate(`/admin/workspaces/event-operations/events/${encodeURIComponent(event.event_uuid)}/${item.key}`),
  }));
  if (!actions.length) return null;
  if (onlyCasting) return <DsButton variant="secondary" size="sm" onClick={actions[0].onClick}>キャスティング一覧</DsButton>;
  return <div className={`event-navigation-menu event-navigation-menu--${placement}`}
    onClick={e => e.stopPropagation()} onKeyDown={e => e.stopPropagation()}>
    <DetailActionMenu label={event.name || 'イベントメニュー'} triggerLabel={`${event.name || 'イベント'}のメニュー`} actions={actions} />
    {assignmentOpen && actions.some(action => action.key === 'assignments') ? (
      <EventListAssignmentModal key={event.event_uuid} eventUuid={event.event_uuid} adminId={getAdminId({ user })}
        onClose={() => setAssignmentOpen(false)} onSaved={onAssignmentsSaved} />
    ) : null}
  </div>;
}
